import imageUrlBuilder from "@sanity/image-url";
import clsx from "clsx";
import Loma from "~/assets/svg/Loma";
import { dataset, projectId } from "~/sanity";
import type { Author } from "~/types";

const BlogHero = ({
  date,
  author,
  title,
  href,
}: {
  date: string;
  author: Author;
  title: string;
  href?: string;
}) => {
  const builder = imageUrlBuilder({ projectId, dataset });

  const renderHeading = () => {
    return (
      <h1
        className={clsx([
          "mx-auto mb-6 max-w-4xl px-6 text-center font-logo text-3xl text-text-black",
          "md:max-w-[760px] md:px-0 md:text-5xl",
        ])}
      >
        {title}
      </h1>
    );
  };

  return (
    <section
      className={clsx([
        "bg-green-primary relative grid w-full grid-flow-row auto-rows-auto overflow-hidden pb-16",
        "md:pb-24",
        "2xl:pt-24",
      ])}
    >
      <div
        className={clsx([
          "mx-auto -mt-[100px] w-[180px]",
          "md:-mt-[80px] md:w-[200px]",
        ])}
      >
        <Loma
          width="100%"
          height="auto"
        />
      </div>
      <div
        className={clsx([
          "mx-auto mb-6 pt-8 text-center font-apercu text-xl text-text-black text-text-gray",
          "md:text-2xl",
        ])}
      >
        {date}
      </div>
      {href ? (
        <a
          href={href}
          className="text-text-black hover:underline"
        >
          {renderHeading()}
        </a>
      ) : (
        renderHeading()
      )}
      <div className="mt-2 flex">
        <div className="mx-auto flex flex-row items-center">
          <div className="mr-3">
            <div
              className={clsx([
                "h-[40px] w-[40px] rounded-full bg-tan-lightest",
                "md:h-[50px] md:w-[50px]",
              ])}
            >
              <img
                src={builder
                  .image(author.image)
                  .width(100)
                  .height(100)
                  .quality(80)
                  .url()}
                alt={author.name}
                className="h-full w-full rounded-full"
                itemProp="image"
              />
            </div>
          </div>
          <div
            className={clsx([
              "mx-auto max-w-[360px] text-center font-apercu text-xl text-text-black",
              "md:text-2xl",
            ])}
          >
            {author.name}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogHero;
